import styled from 'styled-components';

export const PasswordRecoveryLink = styled.a`
    clear: both;
    float: right;
    font-size: 12px;
    margin: 6px 0 10px 0;
    text-decoration: underline;
`;
